/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.moment = require('moment'); // Carico il pacchetto NPM 'moment'

// window.Vue = require('vue');
import Vue from 'vue';

import vuetify from './plugins/vuetify'
import router from './router';
import store from './store';

import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

import Mixins from './mixins';
Vue.mixin(Mixins);

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import UUID from "vue-uuid";
Vue.use(UUID);

// import CKEditor from '@ckeditor/ckeditor5-vue2';
// Vue.use( CKEditor );

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

import ZoomOnHover from "vue-zoom-on-hover";
Vue.use(ZoomOnHover);

// ============= Se una richiesta axios torna 499 (non autorizzato) reindirizza alla pagina di login =============
import axios from 'axios';
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 499) { // Il BE avrà eseguito il logout
      window.location.href = '/'; // Reindirizza alla pagina di login
    }
    return Promise.reject(error);
  }
);
// ================================================================================================================


// axios.defaults.baseURL = 'http://localhost:8000/';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))
// NOTA ^^^: Il codice sopra probabilmente non posso usarlo perché la cartella dei Component in realtà ho anche le routes (le views)

Vue.component('prova-gratuita-component', require('./components/ProvaGratuitaComponent.vue').default);
// Vue.component('stats-cday-component', require('./components/StatsCDayComponent.vue').default); => Per ora commentato. Quest'anno forse cambia
Vue.component('root-component', require('./components/RootComponent.vue').default);

Vue.component('home-component', require('./components/HomeComponent.vue').default);
Vue.component('login-component', require('./components/LoginComponent.vue').default);
// Vue.component('simulazione-component', require('./components/SimulazioneComponent.vue').default);
// Vue.component('simulazione-old-component', require('./components/SimulazioneOldComponent.vue').default);
Vue.component('simulazione-veneto-component', require('./components/Altro/SimulazioneVenetoComponent.vue').default);
// Vue.component('risultato-component', require('./components/RisultatoComponent.vue').default);

Vue.component('statistiche-cliccatore-component', require('./components/Statistiche/StatisticheCliccatoreComponent.vue').default);
Vue.component('statistiche-squadre-component', require('./components/Statistiche/StatisticheSquadreComponent.vue').default);
Vue.component('statistiche-azienda-component', require('./components/Statistiche/StatisticheAziendaComponent.vue').default);
// Vue.component('chart-component', require('./components/ChartComponent.vue').default);
Vue.component('chart-pie-component', require('./components/Statistiche/ChartPieComponent.vue').default);
Vue.component('chart-line-component', require('./components/Statistiche/ChartLineComponent.vue').default);

// GAMING
Vue.component('root-gaming-component', require('./components/Gaming/RootComponent.vue').default);
Vue.component('dashboard-gaming-component', require('./components/Gaming/DashboardComponent.vue').default);
Vue.component('click-day-box-component', require('./components/Gaming/ClickDayBoxComponent.vue').default);
Vue.component('dati-di-fatturazione-component', require('./components/Gaming/DatiDiFatturazioneComponent.vue').default);
Vue.component('gestione-screenshot-ed-esiti-component', require('./components/Gaming/GestioneScreenshotEdEsitiComponent.vue').default);
// Vue.component('click-day-gaming-component', require('./components/Gaming/ClickDayComponent.vue').default);
Vue.component('game-day-component', require('./components/Gaming/GameDayComponent.vue').default);
Vue.component('click-day-component', require('./components/Gaming/ClickDayComponent.vue').default);
Vue.component('classifica-gaming-component', require('./components/Gaming/CassificaComponent.vue').default);
Vue.component('compensi-component', require('./components/Gaming/CompensiComponent.vue').default);
Vue.component('modifica-esito-clickday-component', require('./components/Gaming/ModificaEsitoClickdayComponent.vue').default);
Vue.component('game-day-box-component', require('./components/Gaming/GameDayBoxComponent.vue').default);
// Vue.component('click-day-box-component', require('./components/Gaming/ClickDayBoxComponent.vue.off').default);
Vue.component('simulazione-game-day-component', require('./components/Gaming/SimulazioneGameDayComponent.vue').default);
Vue.component('risultato-game-day-component', require('./components/Gaming/RisultatoGameDayComponent.vue').default);

Vue.component('dati-azienda-clickday-component', require('./components/Altro/DatiAziendaClickdayComponent.vue').default);

Vue.component('dati-cliccatore-component', require('./components/DatiCliccatoreComponent.vue').default);
Vue.component('clipboard-component', require('./components/ClipboardComponent.vue').default);

// Vue.component('nuova-oppure-modifica-notifica-component', require('./components/backoffice/notifiche/NuovaOppureModificaNotificaComponent.vue').default);

Vue.component('ricariche-component', require('./components/RicaricheComponent.vue').default);

Vue.component('accettazione-regole', require('./components/AccettazioneRegole.vue').default);

Vue.component('domande-risposte-component', require('./components/Simulazioni/DomandeRisposteComponent.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store,
    router,
    vuetify
});
